import React from "react"
import { BLOCKS } from "@contentful/rich-text-types"

import { RichText } from "components"

function Card({ address, city, facilityType }) {
  return (
    <li className="px-4 pt-4 pb-6 space-y-4 border-b-2 bg-marble border-violet">
      <p className="lead-bold">{city}</p>
      {facilityType && <p className="body">{facilityType.name}</p>}
      {address && (
        <RichText
          content={address}
          options={{
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, children) => (
                <p className="small-copy">{children}</p>
              ),
            },
          }}
        />
      )}
    </li>
  )
}

export default Card
